<template>
    <body class="nojs">
        <div class="LayoutHolder" id="PageTop">
            <Header></Header>
            <BreadCrumbs :breadCrumbs="this.breadCrumbs" id ="PageTop"></BreadCrumbs>
            <router-view />
            <Footer></Footer>
        </div>
    </body>
</template>

<script>

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import BreadCrumbs from "@/components/BreadCrumbs.vue";
import DettagliUtente from "@/models/dettagliUtente.model.js";
import {apiMixin} from "/mixin.js";

export default {
    name: "Default",
    components:{
        Header,
        Footer,
        BreadCrumbs,
        Header      
    },   
    data(){
        return {
            breadCrumbs: []
        }
    },
    mixins: [apiMixin],
    mounted: function(){     
        this.breadCrumbs = this.$route.meta.breadCrumbs;
        
        document.body.classList.add('nojs');
        document.body.classList.remove('LoginPage');  
        
        this.$store.dispatch({
            type: "getSiti",
            token: this.$store.getters.getUtente.Token,
        });

        this.$store.dispatch({
            type: "getArticoli",
            token: this.$store.getters.getUtente.Token,
        });

        this.$store.dispatch({
            type: "getMagazzini",
            token: this.$store.getters.getUtente.Token,
        });
        this.$store.dispatch({
            type: "getStatiIntervento",
            token: this.$store.getters.getUtente.Token,
        });

        this.$store.dispatch({
            type: "getStatiContratto",
            token: this.$store.getters.getUtente.Token,
        });
        this.$store.dispatch({          
            type: "getEntita",
            token: this.$store.getters.getUtente.Token,
        });

        this.$store.dispatch({          
            type: "getUnita",
            token: this.$store.getters.getUtente.Token,
        });

        this.$store.dispatch({          
            type: "getReparti",
            token: this.$store.getters.getUtente.Token,
        });

        this.doApiCall("get", "utenti/GetInfoUtenteAreaRis", this.$store.getters.getUtente.Token).then(

            (data) => {                
                if(data){       
                    let dettagliUtente = new DettagliUtente();                    
                    Object.assign(dettagliUtente, data)
                    this.$store.commit("setDettagliUtente", dettagliUtente);
                }
            }
        );
        
    },
    beforeRouteUpdate (to, from, next) {     
        this.breadCrumbs = to.meta.breadCrumbs;
        next();
    } 
}
</script>
